<template>
  <base-page
    :title="'Schedule Planner'"
    :large-layout="true"
    :full-width="true"
  >
    <template #actionButton>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            rounded
            color="primary"
            v-on="on"
          >
            {{ $t('schedule.actionButton') }}
            <v-icon right>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <schedule-group-dialog
            :model="scheduleGroupDialogModel"
            :mode="scheduleGroupDialogMode"
            @cancel="scheduleGroupDialogModel = false"
          />

          <v-list-item
            @click="openScheduleGroupDialog('create')"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left small>add</v-icon>
                Add Group
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="openScheduleGroupDialog('list')"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left small>settings</v-icon>
                Manage Groups
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-menu>
    </template>

    <template #main>
      <schedule-calendar />
    </template>
  </base-page>
</template>

<script>
import BasePage from '@/views/BasePage.vue'
import ScheduleGroupDialog from "../../components/ScheduleGroup/ScheduleGroupDialog"
import ScheduleCalendar from "../../components/Calendar/ScheduleCalendar"

export default {
  components: {
    ScheduleCalendar,
    ScheduleGroupDialog,
    BasePage,
  },
  data() {
    return {
      scheduleGroupDialogModel: false,
      scheduleGroupDialogMode: '',
    }
  },
  methods: {
    openScheduleGroupDialog(mode) {
      setTimeout(() => {
        this.scheduleGroupDialogModel = true
        this.scheduleGroupDialogMode = mode
      })
    },
  }
}
</script>
